<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>查询条件</span>
      </div>
      <div class="text item">
        <el-form :inline="true" :model="storeAdsManageInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-form-item>
              <el-input v-model="storeAdsManageInfo.conditions.adName" placeholder="请输入广告名称" clearable>
              </el-input>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-select v-model="storeAdsManageInfo.conditions.adType" placeholder="请选择广告类型" style="width:100%"
                clearable>
                <el-option v-for="item in storeAdsManageInfo.adTypes" :key="item.statusCd" :label="item.name"
                  :value="item.statusCd">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_queryStoreAdsMethod">
              <i class="el-icon-search"></i>查询
            </el-button>
            <el-button @click="_resetStoreAdsMethod">
              <i class="el-icon-refresh"></i>重置
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="box-card" style="margin-top:20px">
      <div slot="header" class="flex justify-between">
        <span>店铺广告</span>
        <el-button type="primary" size="small" style="float:right" @click="_openAddStoreAdsModal">
          <i class="el-icon-plus"></i>发布
        </el-button>
      </div>
      <div class="text item">
        <el-table :data="storeAdsManageInfo.storeAdss" border style="width:100%">
          <el-table-column prop="adName" label="广告名称" align="center"></el-table-column>
          <el-table-column prop="adTypeCdName" label="广告类型" align="center"></el-table-column>
          <el-table-column label="广告图片" align="center">
            <template slot-scope="scope">
              <el-image style="width:50px;height:50px" :src="scope.row.imgUrl" :preview-src-list="[scope.row.imgUrl]"
                fit="cover">
                <div slot="error" class="image-slot">
                  <img src="/img/noPhoto.jpg" style="width:50px;height:50px">
                </div>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column prop="seq" label="顺序" align="center"></el-table-column>
          <el-table-column prop="startTime" label="开始时间" align="center"></el-table-column>
          <el-table-column prop="endTime" label="结束时间" align="center"></el-table-column>
          <el-table-column prop="createTime" label="发布时间" align="center"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button size="mini" @click="_openEditStoreAdsModel(scope.row)">修改
              </el-button>
              <el-button size="mini" type="danger" @click="_openDeleteStoreAdsModel(scope.row)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="storeAdsManageInfo.total">
        </el-pagination>
      </div>
    </el-card>

    <add-store-ads ref="addStoreAds" @refresh="_queryStoreAdsMethod()"></add-store-ads>
    <edit-store-ads ref="editStoreAds" @refresh="_queryStoreAdsMethod()"></edit-store-ads>
    <delete-store-ads ref="deleteStoreAds" @refresh="_queryStoreAdsMethod()"></delete-store-ads>
  </div>
</template>

<script>
import { listMallAd } from '@/api/storeAds/storeAdsApi'
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'
import AddStoreAds from '@/components/phone/addStoreAds/addStoreAds'
import EditStoreAds from '@/components/phone/editStoreAds/editStoreAds'
import DeleteStoreAds from '@/components/phone/deleteStoreAds/deleteStoreAds'

export default {
  components: {
    AddStoreAds,
    EditStoreAds,
    DeleteStoreAds
  },
  data() {
    return {
      storeAdsManageInfo: {
        storeAdss: [],
        total: 0,
        records: 1,
        adTypes: [],
        conditions: {
          adName: '',
          adType: '',
          advertType: '',
          shopId: '',
          page: 1,
          row: 10
        }
      },
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this._listStoreAdss(this.currentPage, this.pageSize)
    this.getDictData()
  },
  methods: {
    async getDictData() {
      try {
        const { data } = await getDict('store_ads', 'ad_type')
        this.storeAdsManageInfo.adTypes = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async _listStoreAdss(page, rows) {
      this.storeAdsManageInfo.conditions.page = page
      this.storeAdsManageInfo.conditions.row = rows
      let shopId = getShopId()
      this.storeAdsManageInfo.conditions.shopId = shopId

      try {
        const res = await listMallAd(this.storeAdsManageInfo.conditions)
        this.storeAdsManageInfo.total = res.total
        this.storeAdsManageInfo.records = res.records
        this.storeAdsManageInfo.storeAdss = res.data
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this._listStoreAdss(this.currentPage, this.pageSize)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listStoreAdss(this.currentPage, this.pageSize)
    },
    _openAddStoreAdsModal() {
      this.$refs.addStoreAds.open()
    },
    _openEditStoreAdsModel(row) {
      this.$refs.editStoreAds.open(row)
    },
    _openDeleteStoreAdsModel(row) {
      this.$refs.deleteStoreAds.open(row)
    },
    _queryStoreAdsMethod() {
      this.currentPage = 1
      this._listStoreAdss(this.currentPage, this.pageSize)
    },
    _resetStoreAdsMethod() {
      this.storeAdsManageInfo.conditions = {
        adName: '',
        adType: '',
        advertType: '',
        shopId: '',
        page: 1,
        row: 10
      }
      this._listStoreAdss(1, this.pageSize)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>